import ComparePage from './CompareLayout';
import { CAYDA, ADV } from './caydaFacts';

const VsBugherd = () => (
  <ComparePage
    slug="bugherd"
    competitor="BugHerd"
    description="BugHerd alternative: Cayda pins feedback on your live site with a free plan, a $9 entry price, and Jira, Asana and Linear on a $14 tier instead of $125."
    hero="The BugHerd alternative without the seat blocks."
    intro="BugHerd sells feedback in blocks of members: five on Standard, twenty five on Premium, with the tracker integrations on the $125 tier. Cayda charges a base fee plus the people who actually accept an invite, puts Jira, Asana and Linear on a $14 plan, and starts free."
    verdict={[
      { label: 'Starting price', cayda: '$9/mo', other: '$42/mo' },
      { label: 'Free plan', cayda: 'Yes, no clock', other: '7 day trial' },
      { label: 'Jira, Asana, Linear', cayda: '$14 tier', other: '$125 tier' },
      { label: 'Owner seat', cayda: 'Covered', other: 'Counts as a member' },
    ]}
    advantages={[
      { ...ADV.pricing, body: 'A base fee covers you; each accepted teammate is $5 to $6. Two people pay $14, not $42. Ten people with Jira pay $68, not $125. Nobody buys seats they are not using.' },
      ADV.invisible,
      ADV.dashboard,
      ADV.capture,
    ]}
    cost={{
      note: 'Annual billing, per month. BugHerd pricing from bugherd.com/pricing, September 2026.',
      scenarios: [
        { label: 'Solo freelancer', detail: 'unlimited sites', cayda: 9, other: 42, caydaPlan: 'Pro, owner covered', otherPlan: 'Standard, 5 seat block' },
        { label: 'Team of five, Slack', detail: 'status, priority, assignment, CSV', cayda: CAYDA.proPrice(4), other: 42, caydaPlan: 'Pro + 4 members', otherPlan: 'Standard' },
        { label: 'Team of five, Jira', detail: 'plus Asana, Linear, screen recording, guests', cayda: CAYDA.teamPrice(4), other: 125, caydaPlan: 'Team + 4 members', otherPlan: 'Premium, 25 seat block' },
      ],
    }}
    features={{
      note: 'Cayda plan names in the Cayda column. BugHerd details from bugherd.com/pricing and /features, September 2026.',
      rows: [
        ['Free plan', CAYDA.free, 'None'],
        ['Entry paid plan', CAYDA.pro, '$42 · 5 members'],
        ['Jira, Asana, Linear', CAYDA.team, '$125 tier'],
        ['Slack', 'Pro', 'All plans'],
        ['Extra members', '$5 to $6', '$6.60'],
        ['Owner covered by base fee', true, false],
        ['Websites on paid plans', 'Unlimited', 'Unlimited'],
        ['Visible to site visitors', 'Never', 'Optional public widget'],
        ['Auto screenshot, browser, OS, viewport', true, true],
        ['Screen recording', 'Team', 'Video, one minute cap'],
        ['Kanban + list dashboard, bulk actions', true, 'Kanban board'],
        ['Client / guest reviewers', 'Team, no member fee', 'Unlimited guests'],
        ['CSV export', 'Pro', 'All plans'],
        ['WordPress plugin, Shopify app', true, 'WordPress'],
      ],
    }}
    approach={[
      'BugHerd has been pinning feedback to websites since 2011 and prices it in member blocks: Standard includes five members at $42 a month, Premium includes twenty five at $125 and is where Jira, Asana and Linear live. The owner takes one of those seats, and every member past the block is $6.60.',
      'Cayda covers the same loop, click on the page, leave a note pinned to the element, triage it in a board, push it to your tracker, with a free plan, a base fee that includes the owner, and per-member pricing that only bills people who accept an invite.',
    ]}
    bottomLine={[
      'For a freelancer, a studio, or a team under twenty, Cayda costs a fraction of BugHerd for the same workflow, and it never shows anything to your visitors. Try it free on two sites before you decide.',
    ]}
  />
);

export default VsBugherd;
